// @ts-check
// "Enviar de" da nova conversa por e-mail: o endereço da instituição ou uma conta Google ou Microsoft da própria
// pessoa (contrato 08 da agenda, seção 7). Sem conta conectada, nada aparece.
import { html } from 'htm/preact';
import { useEffect, useState } from 'preact/hooks';
import { listConnectedAccounts } from '../../data/calendar.js';
import { Icon } from '../../ui/icon.js';
import { t } from '../../i18n/index.js';

/**
 * @param {{ value: string, onChange: (connectedAccountId: string) => void }} props
 */
export function SenderAccountSelect({ value, onChange }) {
  const [accounts, setAccounts] = useState(/** @type {import('../../data/calendar.js').ConnectedAccount[]} */ ([]));
  useEffect(() => {
    listConnectedAccounts()
      .then((data) => setAccounts(data.accounts.filter((account) => account.isMine && !account.authFailedAt)))
      .catch(() => setAccounts([]));
  }, []);
  if (accounts.length === 0) return null;
  return html`<label class="form-field">
    <span class="form-field-label"><${Icon} name="IconAt" size=${14} /><span>${t('calendar.compose.from')}</span></span>
    <select class="text-input" value=${value} onChange=${(event) => onChange(/** @type {HTMLSelectElement} */ (event.currentTarget).value)}>
      <option value="">${t('calendar.compose.institutionAddress')}</option>
      ${accounts.map((account) => html`<option key=${account.id} value=${account.id}>${account.handle}</option>`)}
    </select>
  </label>`;
}
